import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbDatepickerI18n, NgbDatepickerModule, NgbDropdownModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LaddaModule } from 'angular2-ladda';
import { IntercomModule } from 'ng-intercom';
import { VoxAudioPlayerModule, VoxPhoneTextFieldModule, VoxTimezoneInputModule, VoxToggleModule } from 'ng-voxloud';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { environment } from 'src/environments/environment';

import { ROUTES } from './app.routes';
import {
  AccountService,
  AiListComponent,
  AppComponent,
  AuthErrorInterceptor,
  AuthService,
  BringAFriendComponent,
  CallHistoryComponent,
  CallHistoryFilterPopupComponent,
  CallHistoryFiltersComponent,
  CallHistoryService,
  CallLogDetailsComponent,
  CallLogSmsComponent,
  CallLogTableComponent,
  CallRecordingComponent,
  CallTypeChipComponent,
  ChatComponent,
  ClipboardBoxComponent,
  ContactDetailsComponent,
  ContactListComponent,
  ContactListResolve,
  ContactListService,
  CustomDatePickerTranslateService,
  DidsComponent,
  DidsResolve,
  DidsService,
  ErrorComponent,
  FilterDateComponent,
  FilterDateTimeComponent,
  FilterDateTimeRangeComponent,
  FilterDidComponent,
  FilterDropdownComponent,
  FilterIntervalComponent,
  FilterTextComponent,
  FilterTimeComponent,
  FilterTimeRangeComponent,
  FilterUsersComponent,
  LocaleService,
  OptionsComponent,
  OverviewComponent,
  PaginationComponent,
  ReferralService,
  SentimentScoreComponent,
  SessionResolver,
  SessionService,
  SubscriptionService,
  ToolsComponent,
  VoicemailComponent,
  WebhookListComponent,
} from './components/';
import { ClickOutsideDirective } from './directives/clickoutside.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { SanitizeNumberLinkPipe } from './pipes/sanitize-number-link.pipe';
import { SanitizeUrlPipe } from './pipes/sanitize-url.pipe';
import { SecondsToMinutesPipe } from './pipes/seconds-to-minutes.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { ChatService } from './services/chat.service';
import { PBXService } from './services/pbx.service';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltip,
    VoxAudioPlayerModule,
    VoxTimezoneInputModule,
    TimepickerModule,
    NgbDatepickerModule,
    TranslateModule.forRoot(),
    TooltipModule.forRoot(),
    RouterModule.forRoot(ROUTES, { useHash: true }),
    IntercomModule.forRoot({
      appId: environment.INTERCOM_ID,
      updateOnRouterChange: true,
    }),
    NgbDropdownModule,
    VoxToggleModule,
    NgxSkeletonLoaderModule,
    VoxPhoneTextFieldModule,
    LaddaModule,
  ],
  declarations: [
    AppComponent,
    ContactListComponent,
    ContactDetailsComponent,
    OptionsComponent,
    DidsComponent,
    ToolsComponent,
    BringAFriendComponent,
    FilterPipe,
    TranslatePipe,
    ErrorComponent,
    CallHistoryComponent,
    CallLogTableComponent,
    PaginationComponent,
    CallLogDetailsComponent,
    SanitizeUrlPipe,
    SanitizeNumberLinkPipe,
    SecondsToMinutesPipe,
    AiListComponent,
    CallLogSmsComponent,
    SentimentScoreComponent,
    WebhookListComponent,
    CallRecordingComponent,
    VoicemailComponent,
    OverviewComponent,
    CallHistoryFiltersComponent,
    FilterTextComponent,
    FilterIntervalComponent,
    FilterDropdownComponent,
    FilterDidComponent,
    FilterUsersComponent,
    FilterTimeComponent,
    FilterTimeRangeComponent,
    ClickOutsideDirective,
    FilterDateComponent,
    FilterDateTimeComponent,
    FilterDateTimeRangeComponent,
    CallHistoryFilterPopupComponent,
    CallTypeChipComponent,
    ClipboardBoxComponent,
    ChatComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthService,
    ChatService,
    SessionResolver,
    ContactListResolve,
    ContactListService,
    DidsService,
    DidsResolve,
    AccountService,
    SessionService,
    LocaleService,
    ReferralService,
    SubscriptionService,
    CallHistoryService,
    PBXService,
    {
      provide: NgbDatepickerI18n,
      useClass: CustomDatePickerTranslateService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthErrorInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {}
